import './login.css';
import Logo from '../Logo';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { usuariosAPI } from "../../servicos/usuarios";

function Admin(){

    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');

    const Logar = (event) => {
        event.preventDefault();

        const dados = {
            'login': email,
            'senha': senha
        }          

        setExibeErro(false);
        setMensagemErro("");

        if (email === '') {
            setExibeErro(true);
            setMensagemErro("OPS Você esqueceu de informar o email.");
            return;
        }

        if (senha === '') {
            setExibeErro(true);
            setMensagemErro("OPS Você esqueceu de informar a senha.");
            return;
        }

        usuariosAPI.post('/login',dados)
        .then(resposta => {
            sessionStorage.setItem('token', resposta.data.token);
            CarregarDados(email);
        })
        .catch(erro => {
            console.error('Erro ao fazer login administrativo', {
                url: usuariosAPI.defaults.baseURL + '/login',
                status: erro?.response?.status,
                statusText: erro?.response?.statusText,
                data: erro?.response?.data,
                headers: erro?.response?.headers,
                message: erro?.message
            });
            if(erro?.response?.data?.message){
                setExibeErro(true);
                setMensagemErro(erro.response.data.message);
            }else{
                setExibeErro(true);
                setMensagemErro('Ops! Ocorreu um erro inesperado.');
            }        
        })            
    }    

    const CarregarDados = (email) => {
        usuariosAPI.get('/',)
        .then(resposta => {
            const encontrado = resposta.data.find((usuario) => usuario.us100_dsc_email === email);
            if (encontrado) {
                sessionStorage.setItem('Nome', encontrado.us100_dsc_usuario);
                Entrar();
                return;
            }
            if(email === "master@ledupa.com.br"){
                sessionStorage.setItem('Nome', 'Master');
                Entrar();
                return;
            }
            setExibeErro(true);
            setMensagemErro('Ops! Dados não carregados.');
        }).catch(erro => {
            console.error('Erro ao carregar dados administrativos', {
                url: usuariosAPI.defaults.baseURL + '/',
                status: erro?.response?.status,
                statusText: erro?.response?.statusText,
                data: erro?.response?.data,
                headers: erro?.response?.headers,
                message: erro?.message
            });
            if(erro?.response?.data?.message){
                setExibeErro(true);
                setMensagemErro(erro.response.data.message);
            }else{
                setExibeErro(true);
                setMensagemErro('Ops! Ocorreu um erro inesperado.');
            }        
        })            
    }        

    let navigate = useNavigate();
    const Entrar = () => {
        setEmail('');
        setSenha('');            
        let path = '/admin/filiado';
        navigate(path);
    }

    const [exibeErro, setExibeErro] = useState(false);
    const [mensagemErro, setMensagemErro] = useState('');

    return (
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-lg-8">  
                    <div class="container">
                        <div class="row text-center login align-middle">
                            <div class="col"></div>
                            <div id="login" class="col-12 col-lg-7 d-flex flex-column justify-content-center align-items-center">
                                <Logo/>
                                <h4>Seja bem vindo(a)!</h4>
                                <p>Área Administrativa</p>

                                {exibeErro &&
                                    <div class="alert alert-danger alert-login" role="alert">
                                        <span class="material-symbols-outlined">error</span>
                                        {mensagemErro}
                                    </div>
                                }
                                
                                <form class="row g-3 text-start" onSubmit={Logar}>
                                    <div class="col-md-12">
                                        <label for="inputEmail4" class="form-label">Email</label>
                                        <input type="email" class="form-control" id="email" value={email} onChange={evento => setEmail(evento.target.value)} />
                                    </div>
                                    <div class="col-md-12">
                                        <label for="inputPassword4" class="form-label">Senha</label>
                                        <input type="password" class="form-control" id="senha" value={senha} onChange={evento => setSenha(evento.target.value)}/>
                                    </div>
                                    <div class="col-12 text-center">
                                        <button type="submit" class="btn btn-primary-blue btn-primary">Entrar</button>
                                    </div>
                                </form>
                            </div>
                            <div class="col"></div>
                        </div>
                    </div>
                </div>
                <div id="fundo-login" class="col-12 col-lg-4"></div>
            </div>
        </div>
    )
}

export default Admin;

